import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { articles } from '@/mocks/articles';

export default function ShoppingGuide() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Navbar />
      <main>
        <header className="pt-24 md:pt-28 pb-8 md:pb-12 bg-background-50">
          <div className="max-w-[1440px] mx-auto px-4 md:px-6">
            <div className="max-w-3xl mx-auto text-center">
              <div className="flex items-center justify-center gap-2 text-sm text-foreground-500 mb-4">
                <Link to="/" className="hover:text-primary-600 transition-colors">Home</Link>
                <i className="ri-arrow-right-s-line text-xs"></i>
                <span className="text-foreground-400">Shopping Guide</span>
              </div>
              <h1 className="font-heading text-3xl md:text-5xl font-bold text-foreground-900 leading-tight mb-4">
                Vigorbuy Spreadsheet Shopping Guide
              </h1>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-2xl mx-auto">
                Your complete resource hub for mastering Vigorbuy Spreadsheet. Browse expert guides, tutorials, tips, and in-depth articles covering every aspect of smarter online shopping.
              </p>
            </div>
          </div>
        </header>

        <div className="relative w-full h-[220px] md:h-[300px] overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Clean%20minimalist%20workspace%20with%20laptop%20displaying%20organized%20shopping%20guide%20hub%20interface%20with%20article%20cards%2C%20warm%20cream%20background%2C%20soft%20natural%20window%20light%2C%20modern%20editorial%20style%2C%20knowledge%20resource%20atmosphere%2C%20neutral%20beige%20and%20warm%20terracotta%20tones%2C%20professional%20educational%20aesthetic&width=1400&height=400&seq=vigorbuy-guide-hero&orientation=landscape"
            alt="Vigorbuy Spreadsheet Shopping Guide Hub"
            title="Vigorbuy Spreadsheet Shopping Guide"
            className="w-full h-full object-cover"
          />
        </div>

        <div className="max-w-[1440px] mx-auto px-4 md:px-6 py-12 md:py-16">
          <div className="mb-10">
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 mb-2">
              All Shopping Guides &amp; Articles
            </h2>
            <p className="text-sm text-foreground-600">
              {articles.length} comprehensive guides covering every aspect of Vigorbuy Spreadsheet
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
            {articles.map((article) => (
              <Link
                key={article.slug}
                to={`/article/${article.slug}`}
                className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer block no-underline"
              >
                <div className="aspect-[16/10] w-full overflow-hidden">
                  <img
                    src={article.heroImage}
                    alt={article.title}
                    title={article.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-5 md:p-6">
                  <div className="flex items-center gap-2 mb-3">
                    <span className="px-2.5 py-0.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium">
                      {article.category}
                    </span>
                    <span className="text-xs text-foreground-400">{article.readTime}</span>
                  </div>
                  <h3 className="font-heading font-semibold text-base md:text-lg text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                    {article.title}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">
                    {article.metaDescription}
                  </p>
                  <div className="flex items-center gap-1.5 mt-4 text-sm font-medium text-primary-600">
                    Read Article
                    <i className="ri-arrow-right-line text-xs"></i>
                  </div>
                </div>
              </Link>
            ))}
          </div>

          <div className="text-center mt-12">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-7 py-3.5 rounded-xl text-sm font-semibold bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              Vigorbuy Spreadsheet
              <i className="ri-arrow-right-up-line"></i>
            </a>
          </div>
        </div>

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'CollectionPage',
              name: 'Vigorbuy Spreadsheet Shopping Guide',
              description: 'Complete resource hub for mastering Vigorbuy Spreadsheet with expert guides, tutorials, and tips for smarter online shopping.',
              publisher: {
                '@type': 'Organization',
                name: 'Vigorbuy Spreadsheet Guide',
              },
            }),
          }}
        />
      </main>
      <Footer />
    </>
  );
}